export const addClassNoteOptions = ['Add Class Note']

export const CLIENT_PUBLIC_TOKEN = "TPS Alumni Site, 2002a Spartans"

export const milStatusOptions =
[
   "AD",
   "Ret",
   "Guard",
   "Reserves",
   "Gov't Civilian",
   "Deceased",
]

export const crudClassNoteOptions = [
   'Add Class Note',
   'Delete Class Note',
   'Edit Class Note',
   'Update Class Note'
]

export const historyRadioOptions = [
   'Bullet',
   'Link',
   'Photo',
   'Text'
]

export const milRankOptions =
[
   'Civ',
   'Sgt',
   'TSgt',
   'MSgt',
   'SMSgt',
   'CMSgt',
   '1st Lt',
   'LTJG',
   '1stLt',
   '1Lt',
   'Capt',
   'LT',
   'CPT',
   'Maj',
   'LCDR',
   'MAJ',
   'Lt Col',
   'CDR',
   'LtCol',
   'LTC',
   'Col',
   'CAPT',
   'COL',
   'Brig Gen',
   'RDML',
   'Commodore',
   'BGen',
   'BG',
   'Maj Gen',
   'RADM',
   'MajGen',
   'MG',
   'Lt Gen',
   'VADM',
   'LtGen',
   'LTG',
   'Gen',
   'ADM',
   'GEN',
   'Air Marshall',
   'CW',
]

export const numPhotosToGetOnIntialLoad = 10

export const options =
[
   // 'Astronaut',
   'City',
   // 'Class',
   // 'Commandant',
   'Current Company',
   // 'Current Job Title',
   'Education',
   // 'General Officer',
   // 'Get All Grads',
   'State'
]

export const photoDims = {
   bioPhotoWidth: '80%'
}

export const photoSearchOptions = [
   'Search Photo Captions',
   'Search by Photo Tag',
]

export const superUserPhotoSearchOptions = [
   'Search Photo Captions',
   'Search by Photo Tag',
   'Show Photos that need Approval',
]

export const tpsCourses = {
   ftc: 'Flight Test Course',
   stc: 'Space Test Course',
}

export const trackOptions =
[
   'Pilot',
   'RPA Pilot',
   'FTE',
   'CSO',
   'STC',
]
